const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';

export function getToken(): string | null {
  return localStorage.getItem('token');
}

interface ApiOptions {
  method?: string;
  body?: any;
  params?: Record<string, any>;
}

/**
 * Обёртка над fetch: добавляет JWT-заголовок и базовый URL.
 * При 401 чистит токен и перенаправляет на логин.
 */
export async function apiFetch<T = any>(path: string, options: ApiOptions = {}): Promise<T> {
  const { method = 'GET', body, params } = options;

  let url = `${API_URL}${path}`;
  if (params) {
    const qs = Object.entries(params)
      .filter(([, v]) => v !== undefined && v !== null && v !== '')
      .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(String(v))}`)
      .join('&');
    if (qs) url += `?${qs}`;
  }

  const headers: Record<string, string> = {};
  const token = getToken();
  if (token) headers['Authorization'] = `Bearer ${token}`;
  if (body !== undefined) headers['Content-Type'] = 'application/json';

  const response = await fetch(url, {
    method,
    headers,
    body: body !== undefined ? JSON.stringify(body) : undefined,
  });

  if (response.status === 401) {
    localStorage.removeItem('token');
    window.location.href = '/login';
    throw new Error('Unauthorized');
  }

  if (!response.ok) {
    let detail = `Request failed (${response.status})`;
    try {
      const data = await response.json();
      detail = data.detail || detail;
    } catch (e) {
      // ignore
    }
    throw new Error(detail);
  }

  if (response.status === 204) return undefined as unknown as T;
  return response.json();
}

export { API_URL };

/** Бэкенд отдаёт время в UTC без указания зоны. Если в строке нет таймзоны —
 * считаем её UTC, чтобы корректно сконвертировать в локальное время. */
function _toDate(v: string): Date {
  const hasTz = /[zZ]$|[+-]\d{2}:?\d{2}$/.test(v);
  return new Date(hasTz ? v : v + 'Z');
}

export function formatDateTime(v?: string): string {
  if (!v) return '—';
  return _toDate(v).toLocaleString();
}

export function formatDate(v?: string): string {
  if (!v) return '—';
  return _toDate(v).toLocaleDateString();
}
